<button class="close" mat-button mat-dialog-close>X</button>

<div id="streetview-container">
  <div id="streetview-map" #streetviewMap></div>
  <div id="streetview-pano" #streetviewPano></div>
</div>
